import { render, staticRenderFns } from "./CompTabelaCDADisponivelProtesto.vue?vue&type=template&id=0170ad74&scoped=true&"
import script from "./CompTabelaCDADisponivelProtesto.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCDADisponivelProtesto.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaCDADisponivelProtesto.vue?vue&type=style&index=0&id=0170ad74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170ad74",
  null
  
)

export default component.exports